<template>
  <div v-show="isShow" class="wh100 masking">
    <div class="dialog">
      <div class="dialog-left">
        <img class="xm-logo" src="./../assets/img/login-logo.png" alt="logo" />
      </div>
      <div class="dialog-right">
        <div class="w100 clearfix close-div">
          <div @click="isShow = false" class="close-box">
            <i class="iconfont close-icon">&#xe612;</i>
          </div>
        </div>
        <div class="header w100">{{ $t("findPassword.title") }}</div>
        <div class="input-box input-margin" ref="userForget">
          <div class="icon-box flex-center">
            <img
              style="width: 2.4rem; height: 2.3rem"
              src="./../assets/img/tel-icon.png"
            />
          </div>
          <div class="input-centent">
            <input
              class="wh100"
              :placeholder="$t('findPassword.input_phone')"
              type="tel"
              v-model="phoneNumber"
              maxlength="11"
              @blur="loginEnd"
              @focus="loginEnter"
            />
          </div>
        </div>
        <div class="warn" ref="warnTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{ userWarn }}
        </div>
        <div class="input-box no-margin" ref="checkForget">
          <div class="icon-box flex-center">
            <img
              style="width: 2rem; height: 2.2rem"
              src="./../assets/img/code-icon.png"
            />
          </div>
          <div class="input-centent" style="display: flex">
            <input
              class="h100"
              style="width: 70%"
              :placeholder="$t('findPassword.input_code')"
              type="tel"
              v-model="checkCode"
              maxlength="8"
              @blur="codeEnd"
              @focus="codeEnter"
            />
            <div class="flex-center" style="width: 40%" @click="getCode">
              {{ codeBtn }}
            </div>
          </div>
        </div>
        <div class="warn" ref="checkCodeTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{
            $t("findPassword.code_empty")
          }}
        </div>
        <div class="input-box no-margin" ref="passForget">
          <div class="icon-box flex-center">
            <img
              style="width: 1.6rem; height: 1.8rem"
              src="./../assets/img/password.png"
            />
          </div>
          <div class="input-centent">
            <input
              class="wh100"
              :placeholder="$t('findPassword.input_password')"
              type="password"
              v-model="password"
              maxlength="20"
              @blur="passEnd"
              @focus="passEnter"
            />
          </div>
        </div>
        <div class="warn passwordwarn" ref="passwordTip">
          <i class="iconfont icon-warn">&#xe616;</i>&ensp;{{ passWarn }}
        </div>
        <div class="button" @click="findBtn">
          {{ $t("findPassword.find_now") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sign_rules from "../assets/js/sign_rules.js";
export default {
  data() {
    return {
      isShow: false,
      phoneNumber: "",
      password: "",
      checkCode: "",
      codeBtn: this.$t("findPassword.get_code"),
      userWarn: this.$t("findPassword.phone_warn"),
      passWarn: this.$t("findPassword.pass_warn"),
      timer: null,
    };
  },
  watch: {
    // 保证切换语言时按钮和提示也能切换
    "$i18n.locale"() {
      this.codeBtn = this.$t("findPassword.get_code");
      this.userWarn = this.$t("findPassword.phone_warn");
      this.passWarn = this.$t("findPassword.pass_warn");
    },
  },
  methods: {
    getCode(e) {
      if (
        this.codeBtn === this.$t("findPassword.get_code") &&
        getComputedStyle(this.$refs.warnTip, null).visibility === "hidden"
      ) {
        if (this.phoneNumber.length == 0) {
          this.$refs.warnTip.style.visibility = "visible";
          return;
        }
        let ele = e.target,
          timeScound = 60;
        ele.classList.add("alredy-send");
        this.codeBtn = this.$t("findPassword.resend", { second: timeScound });
        this.timer = setInterval(() => {
          timeScound -= 1;
          this.codeBtn = this.$t("findPassword.resend", { second: timeScound });
          if (timeScound <= 0) {
            ele.classList.remove("alredy-send");
            this.codeBtn = this.$t("findPassword.get_code");
            clearInterval(this.timer);
          }
        }, 1000);

        let param = {
          mobile: this.phoneNumber,
        };
        let sign = this.md5(sign_rules(param));
        param.service = "PCLogin.GetForgetCode";
        param.sign = sign;
        this.$axios.post("/", param).then((response) => {
          let res = response.data.data;
          if (res.code == 0) {
            this.$EventBus.$emit(
              "hide",
              this.$t("findPassword.get_code_success")
            );
          } else {
            if (res.msg) {
              this.$EventBus.$emit("hide", { type: "error", msg: res.msg });
            }
          }
        });
      }
    },
    open() {
      this.isShow = true;
    },
    loginEnter() {
      this.$refs.userForget.style.borderColor = "var(--primary-color)";
      this.$refs.warnTip.style.visibility = "hidden";
    },
    loginEnd() {
      this.$refs.userForget.style.borderColor = "#D9D9D9";
      let reg = /^1\d{10}$/;
      let flag = reg.test(this.phoneNumber);
      if (!flag) {
        this.$refs.warnTip.style.visibility = "visible";
        this.userWarn = this.$t("findPassword.phone_warn");
      } else {
        if (this.$refs.warnTip.style.visibility == "hidden") {
          this.$axios
            .post("/", {
              service: "PCLogin.CheckUserExists",
              user_login: this.phoneNumber,
            })
            .then((response) => {
              let res = response.data.data;
              if (res.code != 0) {
                this.$refs.warnTip.style.visibility = "visible";
                this.userWarn = res.msg;
                return;
              }
            });
        }
      }
      return flag;
    },
    passEnter() {
      this.$refs.passForget.style.borderColor = "var(--primary-color)";
      this.$refs.passwordTip.style.visibility = "hidden";
    },
    passEnd() {
      this.$refs.passForget.style.borderColor = "#D9D9D9";
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/;
      let flag = reg.test(this.password);
      if (!flag) {
        this.$refs.passwordTip.style.visibility = "visible";
      }
      return flag;
    },
    codeEnter() {
      this.$refs.checkForget.style.borderColor = "var(--primary-color)";
      this.$refs.checkCodeTip.style.visibility = "hidden";
    },
    codeEnd() {
      this.$refs.checkForget.style.borderColor = "#D9D9D9";
      let flag =
        this.checkCode && this.checkCode.replace(/[\r\n\s]/g, "").length;
      if (!flag) {
        this.$refs.checkCodeTip.style.visibility = "visible";
      }
      return flag;
    },
    findBtn() {
      if (!this.loginEnd()) return;
      if (!this.passEnd()) return;
      if (!this.codeEnd()) return;
      this.$axios
        .post("/", {
          user_login: this.phoneNumber,
          user_pass: this.password,
          code: this.checkCode,
          service: "PCLogin.UserFindPass",
        })
        .then((response) => {
          let res = response.data.data;
          if (res.code == 0) {
            this.$EventBus.$emit("hide", this.$t("findPassword.success"));
            this.$EventBus.$emit("login");
            this.isShow = false;
          } else {
            if (res.msg) {
              this.$EventBus.$emit("hide", { type: "error", msg: res.msg });
            }
          }
        });
    },
  },
  mounted() {
    this.$EventBus.$on("findPassword", () => {
      this.open();
    });
  },
};
</script>

<style scoped>
.masking {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.3);
}

.dialog {
  width: 90rem;
  min-height: 50rem;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3;
  margin-left: -45rem;
  margin-top: -28rem;
  background: #ffffff;
  border-radius: 0.5rem;
  box-shadow: 0.1rem 0.1rem 1.3rem 0rem rgba(0, 0, 0, 0.43);
  display: flex;
  overflow: hidden;
}

.close-box {
  cursor: pointer;
  width: 1.9rem;
  height: 1.9rem;
  padding: 0.8rem;
  float: right;
  margin-top: 0.5rem;
  margin-right: 0.5rem;
}

.header {
  width: 32rem;
  height: 3.9rem;
  line-height: 3.9rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #39404d;
  text-align: center;
  background: linear-gradient(90deg, #ffc316 4.33%, #fbcb70 122.33%);
  border-radius: 20px;
  margin-top: 8rem;
}

.input-box {
  width: 32rem;
  height: 3.2rem;
  background: #fff;
  margin-top: 3rem;
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  overflow: hidden;
}

.icon-box {
  width: 5.2rem;
  height: 3.2rem;
  background: rgba(236, 233, 233, 0.77);
  border-right: 1px solid #d9d9d9;
  border-radius: 5px 0px 0px 5px;
}

.input-centent {
  width: calc(100% - 4rem);
  height: 100%;
}
.input-centent input {
  padding-left: 1rem;
}

.input-centent > div {
  font-family: Microsoft YaHei;
  color: #ffffff;
  cursor: pointer;
}

.reminder {
  width: 32rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #b78b0e;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.button {
  width: 32rem;
  height: 4rem;
  line-height: 4rem;
  background: linear-gradient(90deg, #fbdd7f 0%, #fbca6f 98.96%);
  border-radius: 5px;
  text-align: center;
  margin-top: 1.6rem;
  margin-bottom: 1.6rem;
  font-size: 1.4rem;
  font-family: Microsoft YaHei;
  color: #39404d;
  cursor: pointer;
}
.dialog-right {
  width: 43.3rem;
  padding-left: 5rem;
}
.warn {
  margin-left: 5rem;
  line-height: 2.4rem;
  height: 3rem;
  color: #fa0505;
  font-size: 1.2rem;
  visibility: hidden;
}
.icon-warn {
  font-size: 1.4rem;
}
.no-margin {
  margin-top: 0;
}
.passwordwarn {
  visibility: hidden;
  height: 2.4rem;
}
.input-margin {
  margin-top: 2.5rem;
}
.input-centent > div {
  font-family: Microsoft YaHei;
  color: #ffffff;
  cursor: pointer;
  background: #eeb308;
}
.input-centent > .alredy-send {
  color: #8e8e93;
  background: #c7c7cc;
}
.dialog-left {
  width: 44.7rem;
  background: url("../assets/img/login-bg.png");
  background-size: 100% 100%;
  color: #fff;
  font-size: 1.4rem;
  text-align: center;
  position: relative;
  left: 0;
  z-index: 1;
}
.download-app {
  margin-top: 3.4rem;
}
.more-game {
  margin-top: 0.6rem;
}
.erweima {
  margin-top: 2.5rem;
  width: 12rem;
  height: 12rem;
}
.system {
  margin-top: 2.5rem;
  font-size: 1.2rem;
}
.xm-logo {
  position: absolute;
  top: 3.2rem;
  left: 2.6rem;
}
.close-div {
  position: relative;
  height: 2rem;
}
.close-icon {
  color: #94979e;
  font-size: 1.2rem;
}
</style>



// WEBPACK FOOTER //
// src/base/findPassword.vue